import React, { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import { Logo } from "@/components/Logo";
import { PasswordInput } from "@/components/PasswordInput";
import { CheckCircle2 } from "lucide-react";
import { useI18n } from "@/i18n";
import api, { formatApiError } from "@/lib/api";

export default function ResetPassword() {
  const { t } = useI18n();
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const token = params.get("token");
  const [pw, setPw] = useState("");
  const [pw2, setPw2] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    if (!token) { setError(t("rp_missing_token")); return; }
    if (pw !== pw2) { setError(t("rp_mismatch")); return; }
    setLoading(true);
    try {
      await api.post("/auth/reset-password", { token, password: pw });
      setDone(true);
      setTimeout(() => navigate("/entrar"), 2500);
    } catch (err) { setError(formatApiError(err.response?.data?.detail) || err.message); }
    finally { setLoading(false); }
  };

  return (
    <div className="min-h-[calc(100vh-4rem)] flex items-center justify-center bg-th-blue th-pattern py-16 px-4">
      <div className="w-full max-w-md bg-white rounded-2xl shadow-2xl p-8">
        <div className="text-center mb-6"><Logo size={54} className="mx-auto" />
          <h1 className="mt-4 font-display font-bold text-2xl text-th-blue">{t("rp_title")}</h1></div>
        {done ? (
          <div className="text-center" data-testid="rp-success">
            <CheckCircle2 className="w-12 h-12 text-green-600 mx-auto mb-4" />
            <p className="text-slate-600">{t("rp_success")}</p>
          </div>
        ) : (
          <form onSubmit={submit} className="space-y-4" data-testid="reset-form">
            <div><Label>{t("rp_new")}</Label>
              <PasswordInput required minLength={6} value={pw} testid="rp-password" onChange={(e) => setPw(e.target.value)} className="mt-1" /></div>
            <div><Label>{t("rp_confirm")}</Label>
              <PasswordInput required minLength={6} value={pw2} testid="rp-password2" onChange={(e) => setPw2(e.target.value)} className="mt-1" /></div>
            {error && <div className="text-red-600 text-sm bg-red-50 rounded p-2" data-testid="rp-error">{error}</div>}
            <Button type="submit" disabled={loading} data-testid="rp-submit" className="w-full bg-th-blue text-white hover:bg-th-bluelight h-11">{loading ? t("loading") : t("rp_submit")}</Button>
            <p className="text-center text-sm"><Link to="/entrar" className="text-th-blue font-semibold hover:text-th-gold">{t("fp_back")}</Link></p>
          </form>
        )}
      </div>
    </div>
  );
}
